import { IReservation, IReservationV2, ITableReservationRecords, ITableReservationTimeSlot } from "./reservations.types";





export const getTableWiseData = (data: ITableReservationTimeSlot[]): ITableReservationRecords => {
    const tableMap: Record<string, { time_slot: string; status: string, reservation_details: IReservationV2[] }[]> = {};
    data.forEach(slot => {
        slot.tables.forEach(table => {
            if (!tableMap[table.table_number]) {
                tableMap[table.table_number] = [];
            }
            tableMap[table.table_number].push({
                time_slot: slot.time_slot,
                status: table.status,
                reservation_details: table.reservation_details
            });
        });
    });

    return tableMap;
}